module.exports = __webpack_public_path__ + "img/17.58cd0a86.jpg";